module.exports = __webpack_public_path__ + "img/icon_instagram.949e13dc.svg";